import { TableCell } from '@mui/material';
import { CopyToClipWhisper } from '@shared/ui/messages/CopyToClipWhisper';
import { formatDateTime } from '@utils/date-helpers';
import { formatWalletAddress } from '@utils/helpers';

export function TransactionOrderId({ row }) {
  return (
    <CopyToClipWhisper
      display={formatWalletAddress(row.order_id)}
      value={row.order_id}
    />
  );
}

export function TransactionCreatedAt({ row }) {
  return <p className="secondary-text">{formatDateTime(row?.created_at)}</p>;
}

export default function TransactionDetailsCell({ row }) {
  return (
    <TableCell>
      <TransactionOrderId row={row} />
      <TransactionCreatedAt row={row} />
    </TableCell>
  );
}
